import { render, staticRenderFns } from "./Welcome_old.vue?vue&type=template&id=221413ea&scoped=true&"
import script from "./Welcome_old.vue?vue&type=script&lang=js&"
export * from "./Welcome_old.vue?vue&type=script&lang=js&"
import style0 from "./Welcome_old.vue?vue&type=style&index=0&id=221413ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221413ea",
  null
  
)

export default component.exports